import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps, InputType } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'

export type TotalFloorsFieldAdditionalProps = {
  className?: string
  isLabelDisplayed?: boolean
  inputType?: InputType
}

// this is noFloors - the total numbers of floors
const TotalFloorsField: React.FC<
  FieldProps<OtherFacilitiesScreenValidationResult> & TotalFloorsFieldAdditionalProps
> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  className,
  isLabelDisplayed = true,
  inputType = 'tel',
}) => {
  const { t } = useTranslation()

  return (
    <TextInput
      id='total-floors-number'
      className={className}
      propertyName='totalFloorsNumber'
      placeholder=''
      label={
        isLabelDisplayed ? (
          <span>{t('wizard.screen.otherFacilities.totalFloorsNumber', 'Total Floors Number')}</span>
        ) : undefined
      }
      ariaLabel={
        !isLabelDisplayed ? t('wizard.screen.otherFacilities.totalFloorsNumber', 'Total Floors Number') : undefined
      }
      value={insertionData.totalFloorsNumber}
      type={inputType}
      numericOnly
      maxLength={3}
      errors={validationMessages?.totalFloorsNumber ?? []}
      doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
    />
  )
}

export default TotalFloorsField
